<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-user"></i>
      <h3>Datos Personales</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-user-edit"></i>
      <p>No hay datos personales disponibles</p>
    </div>

    <div *ngIf="hasData" class="data-sections">
      <!-- Información Básica -->
      <div class="section">
        <h4 class="section-title">Información Básica</h4>
        <div class="data-grid">
          <div class="data-item featured">
            <label>Nombre Completo:</label>
            <span class="value">{{ fullName }}</span>
          </div>

          <div class="data-item" [class.empty]="!data?.rfc">
            <label>RFC:</label>
            <span [class]="data?.rfc ? 'value' : 'placeholder'">
              {{ data?.rfc || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.curp">
            <label>CURP:</label>
            <span [class]="data?.curp ? 'value' : 'placeholder'">
              {{ data?.curp || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.birthDate">
            <label>Fecha de Nacimiento:</label>
            <span [class]="data?.birthDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.birthDate) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.sex">
            <label>Género:</label>
            <span [class]="data?.sex ? 'value' : 'placeholder'">
              {{ formatGender(data?.sex) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.nationality">
            <label>Nacionalidad:</label>
            <span [class]="data?.nationality ? 'value' : 'placeholder'">
              {{ data?.nationality || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Información Adicional -->
      <div class="section">
        <h4 class="section-title">Información Adicional</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="!data?.socialSecurityNumber">
            <label>Número de Seguridad Social:</label>
            <span [class]="data?.socialSecurityNumber ? 'value' : 'placeholder'">
              {{ data?.socialSecurityNumber || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.maritalStatus">
            <label>Estado Civil:</label>
            <span [class]="data?.maritalStatus ? 'value' : 'placeholder'">
              {{ data?.maritalStatus || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.driverLicenseNumber">
            <label>Licencia de Conducir:</label>
            <span [class]="data?.driverLicenseNumber ? 'value' : 'placeholder'">
              {{ data?.driverLicenseNumber || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.voterKeyIFE">
            <label>Clave de Elector:</label>
            <span [class]="data?.voterKeyIFE ? 'value' : 'placeholder'">
              {{ data?.voterKeyIFE || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="data?.dependentsNumber === null || data?.dependentsNumber === undefined">
            <label>Número de Dependientes:</label>
            <span [class]="data?.dependentsNumber !== null && data?.dependentsNumber !== undefined ? 'value' : 'placeholder'">
              {{ data?.dependentsNumber !== null && data?.dependentsNumber !== undefined ? data?.dependentsNumber : 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.residence">
            <label>Residencia:</label>
            <span [class]="data?.residence ? 'value' : 'placeholder'">
              {{ data?.residence || 'No especificado' }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.personType">
            <label>Tipo de Persona:</label>
            <span [class]="data?.personType ? 'value' : 'placeholder'">
              {{ data?.personType || 'No especificado' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Información de Defunción (si aplica) -->
      <div class="section" *ngIf="data?.deathIndicator || data?.deathDate">
        <h4 class="section-title">Información de Defunción</h4>
        <div class="data-grid">
          <div class="data-item" [class.empty]="data?.deathIndicator === null || data?.deathIndicator === undefined">
            <label>Indicador de Defunción:</label>
            <span [class]="data?.deathIndicator !== null && data?.deathIndicator !== undefined ? 'value' : 'placeholder'">
              {{ formatDeathIndicator(data?.deathIndicator) }}
            </span>
          </div>

          <div class="data-item" [class.empty]="!data?.deathDate">
            <label>Fecha de Defunción:</label>
            <span [class]="data?.deathDate ? 'value' : 'placeholder'">
              {{ formatDate(data?.deathDate) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
